'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function n(t){if(typeof t!="object")return !1;try{return t.constructor.toString().startsWith("class")}catch(r){return !1}}

exports.a = n;
